import { useState } from "react";
import { Content } from "../Layout";
import Button from "../Button";
import ModalDistrato from "../Modal/modal-distrato";
import usePermission from "../../hooks/usePermission";

/**
 * Chamada para registrar um distrato que ficou pendente.
 *
 * O gestor pode encerrar o vínculo deixando a multa (ou o reembolso) para
 * depois — nesse caso o formando fica em "Encerrado - Aguardando Distrato" e
 * nenhuma linha de distrato existe ainda. Este bloco é o caminho de volta: abre
 * o mesmo modal, agora sem a opção de adiar, e o `POST /distratos` normal
 * registra o distrato de verdade.
 *
 * Fica na aba do Distrato, que é onde o assunto mora: é o lugar que o gestor
 * procura, e é a mesma tela que passa a mostrar a multa depois de registrada.
 * O formato segue o aviso de "formando sem financeiro criado" do Financeiro.
 */
export default function TraineePendingDistrato({ trainee, reloadTraineeData, onCompleted }) {
  const canDistrato = usePermission("trainee", "distrato");
  const [showModal, setshowModal] = useState(false);

  if (trainee?.bond_status !== "encerrado_aguardando_distrato") return null;

  return (
    <>
      <Content className="mb-3">
        <h2 className="mini-title">Distrato Pendente:</h2>
        <p className="small-label mb-2 mt-1">
          O vínculo deste formando foi encerrado, mas a multa (ou o reembolso) ainda não foi lançada. Registre o
          distrato para concluir o acerto financeiro.
        </p>
        <Button
          style={{ maxWidth: "200px" }}
          color="error"
          onClick={() => {
            setshowModal(true);
          }}
          disabled={!canDistrato}
          title={!canDistrato ? "Você não tem permissão para realizar essa ação." : undefined}
          data-vertical="true"
        >
          Registrar Distrato
        </Button>
      </Content>
      <ModalDistrato
        show={showModal}
        onHide={() => {
          setshowModal(false);
        }}
        trainee={trainee}
        // adiar de novo não faz sentido: o vínculo já está encerrado
        allowDefer={false}
        // a data que vale é a do encerramento, não a de hoje
        defaultDate={trainee?.cancel_date}
        refreshCallback={() => {
          // já estamos na aba do Distrato: recarrega no lugar, sem navegar
          reloadTraineeData && reloadTraineeData();
          onCompleted && onCompleted();
        }}
      />
    </>
  );
}
